import { mapState } from 'vuex'
import { formatDate, formatDatetime } from '@/utils/format'

export default {
    data() {
        return {
            useNoon: true,
        }
    },
    computed: {
        ...mapState(['city', 'date', 'time', 'apiLocked']),
        latitude()  { return this.city?.lat  != null ? Number(this.city.lat)  : null },
        longitude() { return this.city?.lon  != null ? Number(this.city.lon)  : null },
        timezone()  { return this.city?.timezone_slug },
        loc()       { return { lat: this.latitude, lon: this.longitude, timezoneSlug: this.timezone } },
        dailyRange() {
            if (!this.date) return {}
            const d2 = new Date(this.date)
            d2.setDate(this.date.getDate() + 1)
            return { date1: formatDate(this.date), date2: formatDate(d2) }
        },
        monthlyRange() {
            if (!this.date) return {}
            const m1 = new Date(this.date.getFullYear(), this.date.getMonth(), 1)
            const m2 = new Date(m1)
            m2.setMonth(m1.getMonth() + 1)
            return { date1: formatDate(m1), date2: formatDate(m2) }
        },
        yearlyRange() {
            if (!this.date) return {}
            const y1 = new Date(this.date.getFullYear(), 0, 1)
            const y2 = new Date(y1)
            y2.setFullYear(y1.getFullYear() + 1)
            return { date1: formatDate(y1), date2: formatDate(y2) }
        },
        dailyTimeRange() {
            if (!this.date) return {}
            const d2 = new Date(this.date)
            d2.setDate(this.date.getDate() + 1)
            const d1 = this.useNoon
                ? new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 12, 0, 0)
                : (this.time || this.date)
            return { date1: formatDatetime(d1), date2: formatDatetime(d2) }
        },
        currentMonthLabel() {
            if (!this.date) return ''
            return this.date.toLocaleString('en-US', { month: 'long', year: 'numeric' })
        },
    },
    watch: {
        date() { this.useNoon = true },
        city() { this.useNoon = true },
    },
    methods: {
        setNoon() { this.useNoon = true;  this.load() },
        setNow()  { this.useNoon = false; this.load() },
        rotateArrow(value) {
            return `transform:rotate(${value}deg);-ms-transform:rotate(${value}deg);-webkit-transform:rotate(${value}deg);display:inline-block;margin-right:5px;margin-left:5px;font-size:120%`
        },
    },
}
